import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async generateSsoJwt(): Promise<{ token: string; redirectUrl: string }> {
    const url = this.common.constructPath(`/mindtickle/generate-sso-jwt`);
    return this.common.postJSON(url, {});
  }
}
